import { Star } from 'lucide-react';
import { NerdWalletBadge } from '../nerdwallet-badge';
import { RatingTooltip } from './RatingTooltip';

export interface ShortHorizontalLayoutProps {
  hideNwLogo?: boolean;
  reviewLink?: string | null;
  starRating?: number;
  starRatingTooltip?: string;
}

export function ShortHorizontalLayout({
  hideNwLogo = false,
  reviewLink,
  starRating,
  starRatingTooltip,
}: ShortHorizontalLayoutProps) {
  return (
    <div className="flex items-center gap-2" data-testid="rating-component">
      {!hideNwLogo ? <NerdWalletBadge size={14} /> : null}
      {starRating && starRating > 0 ? (
        <>
          <div className="flex items-center gap-0.5">
            {reviewLink ? (
              <a
                className="typography-text-bold text-sm"
                href={reviewLink}
                rel="noreferrer"
                target="_blank"
              >
                {starRating.toFixed(1)}
              </a>
            ) : (
              <span className="typography-text-bold text-sm">{starRating.toFixed(1)}</span>
            )}
            <Star aria-hidden className="fill-current text-primary" size={18} />
          </div>
          {starRatingTooltip ? <RatingTooltip starRatingTooltip={starRatingTooltip} /> : null}
        </>
      ) : (
        <span className="typography-text-small">Not yet rated</span>
      )}
    </div>
  );
}
